import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { routeUrls } from '../../config/routes';
import PermissionDeniedPage from '../../pages/PermissionDeniedPage';

const AdminProtectedRoute = ({ component: Component, ...rest }) => {
  const state = useSelector(state => state);
  const location = useLocation();

  if (!state.auth.isAuthenticated) {
    return (
      <Route
        {...rest}
        render={() => (
          <Redirect
            to={{
              pathname: routeUrls.login,
              state: { from: location },
            }}
          />
        )}
      />
    );
  }

  // Check valid admin role
  if (state.auth.user && (state.auth.user.role === 'ADMIN' || state.auth.user.role === 'SUPER_ADMIN')) {
    return <Route {...rest} render={props => <Component {...props} />} />;
  }

  // Authenticated but not admin -> Permission Denied
  return <Route {...rest} render={props => <PermissionDeniedPage {...props} />} />;
};

export default AdminProtectedRoute;
